// extracted by mini-css-extract-plugin
module.exports = {"container":"carousel-module--container--30_7L","content":"carousel-module--content--38IhH"};